import {
    ASTER_HY_FUND_ID,
    ASTER_SHORT_FUND_ID,
    DAHLIA_FUND_ID,
    DEFAULT_FUND_ID,
    GLOBAL_FIXED_INCOME_FUND_ID,
    IRIS_FUND_ID,
    PERENNE_FUND_ID
} from "./constants";

export interface FoNavFundRiskFactors {
    bondWeights: Record<string, number>;
    cdsWeights: Record<string, number>;
    swapTenorWeights: Record<number, number>;
    swapInstrumentName: string;
}

const ASTER_SHORT_SWAP_TENOR_WEIGHTS: Record<number, number> = {
    3: 0.25,
    4: 0.25,
    5: 0.5
};

const IRIS_SWAP_TENOR_WEIGHT = 1 / 7;

const IRIS_SWAP_TENOR_WEIGHTS: Record<number, number> = {
    6: IRIS_SWAP_TENOR_WEIGHT,
    7: IRIS_SWAP_TENOR_WEIGHT,
    8: IRIS_SWAP_TENOR_WEIGHT,
    9: IRIS_SWAP_TENOR_WEIGHT,
    10: IRIS_SWAP_TENOR_WEIGHT,
    12: IRIS_SWAP_TENOR_WEIGHT,
    15: IRIS_SWAP_TENOR_WEIGHT
};

export const FONAV_FUND_RISK_FACTORS: Record<string, FoNavFundRiskFactors> = {
    [DEFAULT_FUND_ID]: {
        bondWeights: {
            "LFHYP 523": 0.4,
            "LFHYP 524": 0.6
        },
        cdsWeights: {
            "CDX IG 5Y": 0.5,
            "ITRX EUR 5Y": 0.5
        },
        swapTenorWeights: IRIS_SWAP_TENOR_WEIGHTS,
        swapInstrumentName: "SEK/IRS/3M/10Y"
    },
    [ASTER_SHORT_FUND_ID]: {
        bondWeights: {
            "LFHYP 523": 0.3,
            "LFHYP 524": 0.7
        },
        cdsWeights: {
            "CDX IG 5Y": 0.5,
            "ITRX EUR 5Y": 0.5
        },
        swapTenorWeights: ASTER_SHORT_SWAP_TENOR_WEIGHTS,
        swapInstrumentName: "SEK/IRS/3M/10Y"
    },
    [ASTER_HY_FUND_ID]: {
        bondWeights: {
            "LFHYP 523": 0.5,
            "LFHYP 524": 0.5
        },
        cdsWeights: {
            "CDX HY 5Y": 0.5,
            "ITRX XOVER 5Y": 0.5
        },
        swapTenorWeights: {},
        swapInstrumentName: "SEK/IRS/3M/10Y"
    },
    [IRIS_FUND_ID]: {
        bondWeights: {
            "LFHYP 522": 0.25,
            "LFHYP 523": 0.25,
            "LFHYP 524": 0.5
        },
        cdsWeights: {},
        swapTenorWeights: IRIS_SWAP_TENOR_WEIGHTS,
        swapInstrumentName: "SEK/IRS/3M/10Y"
    },
    [GLOBAL_FIXED_INCOME_FUND_ID]: {
        bondWeights: {
            "LFHYP 523": 0.5,
            "LFHYP 524": 0.5
        },
        cdsWeights: {
            "CDX HY 5Y": 0.15,
            "ITRX XOVER 5Y": 0.15,
            "CDX IG 5Y": 0.35,
            "ITRX EUR 5Y": 0.35
        },
        swapTenorWeights: {},
        swapInstrumentName: "SEK/IRS/3M/10Y"
    },
    [PERENNE_FUND_ID]: {
        bondWeights: {
            "LFHYP 520": 0.5,
            "LFHYP 521": 0.5
        },
        cdsWeights: {},
        swapTenorWeights: {},
        swapInstrumentName: "SEK/IRS/3M/10Y"
    },
    [DAHLIA_FUND_ID]: {
        bondWeights: {
            "LFHYP 523": 0.25,
            "LFHYP 524": 0.5,
            "LFHYP 525": 0.25
        },
        cdsWeights: {
            "ITRX EUR 5Y": 1.5
        },
        swapTenorWeights: {
            5: 1
        },
        swapInstrumentName: "SEK/IRS/3M/10Y"
    }
};

export function getFoNavFundRiskFactors(fundId: string): FoNavFundRiskFactors | null {
    return FONAV_FUND_RISK_FACTORS[fundId] ?? null;
}
